import { gsap } from "gsap";

window.addEventListener(
  "load",
  function () {
    if (document.body.classList.contains("post-type-archive-service")) {
      const frame = document.querySelector("#services-introhl-animated");
      const wrapper = frame.querySelector(".lines-wrapper");
      const lines = wrapper.children.length;

      // height of a single line
      //const lineHeight = lines[0].offsetHeight;
      const lineHeight = 100 / lines;
      const tl = gsap.timeline();
      const tlPause = 1.5;
      const tlSpeed = 0.65;

      tl.to({}, { duration: tlPause });

      for (let i = 1; i < lines; i++) {
        tl.to(wrapper, {
          yPercent: -lineHeight * i,
          duration: tlSpeed,
          ease: "back.out(1.2)",
        }).to({}, { duration: tlPause });
      }
    }
  },
  false,
);
